<!--
 * @Description: 移动端首页快捷入口（图片生成、视频生成、AI角色、AI音乐）
 * @Date: 2026-01-12
-->
<template>
    <div class="grid grid-cols-4 gap-2.5 px-0.5 lg:hidden">
        <!-- 图片生成 -->
        <NuxtLink :to="entries[0]?.path" class="mobile-feature-card card-image group cursor-pointer">
            <span class="card-text">{{ entries[0]?.title }}</span>
        </NuxtLink>

        <!-- 视频生成 -->
        <NuxtLink :to="entries[1]?.path" class="mobile-feature-card card-video group cursor-pointer">
            <span class="card-text">{{ entries[1]?.title }}</span>
        </NuxtLink>

        <!-- AI 角色 -->
        <NuxtLink :to="entries[2]?.path" class="mobile-feature-card card-character group cursor-pointer">
            <span class="card-text">{{ entries[2]?.title }}</span>
        </NuxtLink>

        <!-- AI 音乐 -->
        <NuxtLink :to="entries[3]?.path" class="mobile-feature-card card-music group cursor-pointer">
            <span class="card-text">{{ entries[3]?.title }}</span>
        </NuxtLink>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '~/composables/useI18n'

const { t } = useI18n()

// 快捷入口配置
const entries = computed(() => [
    {
        title: t('homeView.image_create'),
        path: '/text-to-image',
    },
    {
        title: t('homeView.video_create'),
        path: '/image-to-video',
    },
    // {
    //     title: t('homeView.ugc_create'),
    //     path: '/characters',
    // },
    {
        title: t('menus.videoEffects'),
        path: '/video-effects',
    },
    {
        title: t('menus.AIMusic'),
        path: '/text-to-music',
    },
])
</script>

<style lang="less" scoped>
.mobile-feature-card {
    color: rgba(255, 255, 255, 0.90);
    background: #191819;
    border-radius: 14px;
    // border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    min-height: 80px;
    padding: 8px 8px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    &:active {
        transform: scale(0.95);
        opacity: 0.8;
    }
}

.card-image {
    background-image: url('https://static.weryai.com/cms/mobiletabBg01.webp');
}

.card-video {
    background-image: url('https://static.weryai.com/cms/mobiletabBg02.webp');
}

.card-character {
    background-image: url('https://static.weryai.com/cms/mobiletabBg03.webp');
}

.card-music {
    background-image: url('https://static.weryai.com/cms/mobiletabBg04.webp');
}

.card-text {
    color: rgba(255, 255, 255, 0.90);
    text-align: left;
    font-family: "PingFang SC";
    font-size: 12px;
    font-weight: 600;
}
</style>
